import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import { FeatureFlags } from '../../Authorizer';
import useCompanyFeatures from '../../Authorizer/useCompanyFeatures';
import LoadingSpinner from '../../Spinner';

const ProcessingStep = ({ blueprint }) => {
  const dispatch = useDispatch();
  const { companyHasFeature } = useCompanyFeatures(FeatureFlags.OCR);

  useEffect(() => {
    if (!companyHasFeature) {
      dispatch(blueprint.nextStep());
    }
  }, [blueprint, companyHasFeature, dispatch]);

  return (
    <LoadingSpinner />
  );
};

ProcessingStep.propTypes = { blueprint: PropTypes.shape({}) };

export default ProcessingStep;
